import { Timesheet } from "globalResources/dataTypes";
import moment from "moment";
import React from "react";
import styled from "styled-components";

const Main = styled.div`
  display: flex;
  flex-direction: row;
  border: 2px solid black;
  justify-content: space-between;
  background-color: white;
  padding: 10px;
  border-radius: 10px;
  width: 450px;
  margin: auto;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
const TimeEntryName = styled.div`
  font-size: 18px;
  font-weight: 800;
`;
const TimeEntryInfo = styled.div`
  font-size: 14px;
  font-weight: 600;
`;
const TimeEntryTime = styled.div``;
const TimeEntryLabel = styled.div`
  font-weight: 800;
  font-size: 14px;
  width: 40px;
`;
const TimeRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

interface Props {
  timeEntry: Timesheet;
}
const TimeEntryDisplay = ({ timeEntry }: Props) => {
  return (
    <Main>
      <Column>
        <TimeEntryName>
          {timeEntry.user.firstName + " " + timeEntry.user.lastName}
        </TimeEntryName>
        <TimeEntryInfo>
          {timeEntry.client?.name} ({timeEntry.position})
        </TimeEntryInfo>
      </Column>
      <Column>
        <TimeRow>
          <TimeEntryLabel>IN:</TimeEntryLabel>
          <TimeEntryTime>
            {moment
              .tz(timeEntry.start, timeEntry.client?.timezone)
              .format("YYYY-MM-DD hh:mmA")}{" "}
          </TimeEntryTime>
        </TimeRow>
        <TimeRow>
          <TimeEntryLabel>OUT:</TimeEntryLabel>
          <TimeEntryTime>
            {moment
              .tz(timeEntry.end, timeEntry.client?.timezone)
              .format("YYYY-MM-DD hh:mmA")}
          </TimeEntryTime>
        </TimeRow>
      </Column>
    </Main>
  );
};
export default TimeEntryDisplay;
